import styled from 'styled-components'

import ConfirmButton from 'components/Buttons/ConfirmButton'
import checkImage from 'images/checkImage.svg'

export const Container = styled.div`
	background: #EFF5F7;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
	box-sizing: border-box;
	padding: 40px 40px 130px;
	font-weight: normal;
	overflow-y: auto;
	
	p {
		color: #224858;
		text-align: center;
		font-size: 24px;
		line-height: 27px;
	}
	
	.thin {
		color: #245e6f;
	}
`

export const Description = styled.div`
	text-align: center;
	white-space: break-spaces;
	margin: 1rem 0;
`

export const CheckImage = styled.img.attrs({
	src: checkImage,
})`
	margin-bottom: 50px;
`

export const GoBackButton = styled(ConfirmButton)`
	position: fixed;
	bottom: 50px;
`
